var map = {
	"./2.png": "b+o+",
	"./2en.png": "6z+O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b0A9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo ^\.\/2.*\.png$
// module id = b0A9
// module chunks = 0